import * as types from "../types/issues.types";
import {
  getListingService,
  postService,
  patchPickService,
  patchInProcessService,
  patchPickBulkService
} from '../../services/issues.service';
import { validationErrors } from "../../utils/Helpers";


export const listAction = (param, data) => {
  return async (dispatch, getState)  => {
    try {
      dispatch({
        type: types.SET_ISSUES_LOADING,
        payload: true,
      });
      await getListingService(getState().authReducer.token, getState().authReducer.user.id, param, data).then((res) => {
        if(res.data.code === 200){
          dispatch({
            type: types.SET_ISSUES_DATA,
            payload: res.data.data,
          });
          dispatch({
            type: types.SET_ISSUES_PAGINATION,
            payload: res.data.pagination,
          });
        }
      });
    } catch (e) {
      validationErrors(e);
    } finally {
      dispatch({
        type: types.SET_ISSUES_LOADING,
        payload: false,
      });
    }
  };
}

export const filterAction = (data) => {  
  return async (dispatch) => {
    try {
      dispatch({
        type: types.SET_ISSUES_FILTER,
        payload: data,
      });
    } catch {}
  }
}

export const addAction = (data) => {
  return async (dispatch, getState) => {
    try {
      await postService(getState().authReducer.token, getState().authReducer.user.id, data)
    } catch (e) {validationErrors(e)}
  };
}

export const editAction = (id, data) => {}

export const pickAction = (data) => {
  return async (dispatch, getState) => {
    try {
      await patchPickService(getState().authReducer.token, getState().authReducer.user.id, data)
    } catch (e) {validationErrors(e)}
  };
}

export const pickBulkAction = (data) => {
  return async (dispatch, getState) => {
    try {
      await patchPickBulkService(getState().authReducer.token, getState().authReducer.user.id, data)
    } catch (e) {validationErrors(e)}
  };
}

export const inProcessAction = (data) => {
  return async (dispatch, getState) => {
    try {
      await patchInProcessService(getState().authReducer.token, getState().authReducer.user.id, data)
    } catch (e) {validationErrors(e)}
  };
}